import { takeLatest, call, put, all } from 'redux-saga/effects';
import URLS from '../constants/urls';
import { callApi } from '../utils/api';
import {
  setExpenseDetails,
  setBillAttachment,
  setBillAttachmentDelete,
  setBillAndDescripion,
} from '../actions/expenseDetailsAction';
import * as SnackbarAction from '../actions/snackbarAction';

function* expenseDetails(action) {
  try {
    const response = yield call(
      callApi,
      URLS.GET_SINGLE_TRANSACTION,
      'GET',
      action.payload,
    );
    yield put(setExpenseDetails(response.res_data, action.showUpdate));
    // yield put(
    //   SnackbarAction.openSnackbar({
    //     message: response.res_str,
    //     type: 'success',
    //   }),
    // );
  } catch (error) {
    // yield put(
    //   SnackbarAction.openSnackbar({
    //     message: error.data.res_str,
    //     type: 'error',
    //   }),
    // );
  }
}

function* billAttachment(action) {
  try {
    const response = yield call(
      callApi,
      URLS.BILL_ATTACHMENT,
      'POST',
      action.payload,
      true,
    );
    yield put(setBillAttachment(response.res_data));
    yield put(
      SnackbarAction.openSnackbar({
        message: response.res_str,
        type: 'success',
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* billCommentUpdate(action) {
  try {
    const hasRole = action.commentData.has_role ? 'Y' : 'N';
    const [responseAttachment, responseComment] = yield all([
      call(callApi, URLS.BILL_ATTACHMENT, 'POST', action.fileData, true),
      call(
        callApi,
        URLS.TRANSACTION_UPDATE,
        'POST',
        action.commentData,
        false,
        hasRole,
      ),
    ]);
    const mergeResObj = Object.assign(
      responseComment.res_data.transaction,
      responseAttachment.res_data,
    );
    yield put(setBillAndDescripion(mergeResObj));
    yield put(
      SnackbarAction.openSnackbar({
        message: 'Transaction attachment and comment updated successfully',
        type: 'success',
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: 'error while updating transaction attachment and comment',
        type: 'error',
      }),
    );
  }
}

function* commentUpdate(action) {
  try {
    const hasRole = action.payload.has_role ? 'Y' : 'N';
    const responseComment = yield call(
      callApi,
      URLS.TRANSACTION_UPDATE,
      'POST',
      action.payload,
      false,
      hasRole,
    );
    yield put(setBillAndDescripion(responseComment.res_data.transaction));
    yield put(
      SnackbarAction.openSnackbar({
        message: 'Transaction comment updated successfully',
        type: 'success',
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: 'error while updating transaction comment',
        type: 'error',
      }),
    );
  }
}

function* billAttachmentDeletion(action) {
  try {
    const response = yield call(
      callApi,
      URLS.EXPENSE_ATTACHMENT_DELETE,
      'POST',
      action.payload,
    );
    yield put(setBillAttachmentDelete(response.res_data));
    yield put(
      SnackbarAction.openSnackbar({
        message: response.res_str,
        type: 'success',
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* disputeWithdrawexpense(action) {
  try {
    const response = yield call(
      callApi,
      URLS.DISPUTE_WITHDRAW,
      'POST',
      action.payloadDispute,
    );
    yield put(
      SnackbarAction.openSnackbar({
        message: response.res_str,
        type: 'success',
      }),
    );
    if (action.callBack) {
      yield put(action.callBack);
    }
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

export function* expenseDetailSaga() {
  yield takeLatest('GET_SINGLE_TRANSACTION', expenseDetails);
  yield takeLatest('BILL_ATTACHMENT', billAttachment);
  yield takeLatest('BILL_COMMENT_UPDATE', billCommentUpdate);
  yield takeLatest('UPDATE_DESCRIPTION', commentUpdate);
  yield takeLatest('BILL_ATTACHMENT_DELETE', billAttachmentDeletion);
  yield takeLatest('DISPUTE_WITHDRAW', disputeWithdrawexpense);
}
